// extracted by mini-css-extract-plugin
export default {"treatmentStateBox":"treatmentStyles_treatmentStateBox__-QwXS"};